import { CurrentUser } from '~/store/store.types';
import { MEMBERSHIP_TIERS } from '~/constants/MembershipTiers'
import { HOUSE_MEMBERSHIPS } from '~/constants/HouseMemberships'
import { FRIENDS_MEMBERSHIPS } from '~/constants/FriendsMemberships'

export const getMembershipTier = (currentUser: CurrentUser): string => {
  if (!currentUser || !currentUser.account) {
    return MEMBERSHIP_TIERS.PUBLIC
  }

  const { membershipTiers } = currentUser.account

  if (!membershipTiers || !membershipTiers.length) {
    return MEMBERSHIP_TIERS.PUBLIC
  }

  const isFriends: boolean = membershipTiers.some(tier => FRIENDS_MEMBERSHIPS.includes(tier))
  const isHouse: boolean = membershipTiers.some(tier => HOUSE_MEMBERSHIPS.includes(tier))

  if (isFriends) {
    return MEMBERSHIP_TIERS.FRIENDS
  } else if (isHouse) {
    return MEMBERSHIP_TIERS.HOUSE
  } else {
    // Defensive by default
    return MEMBERSHIP_TIERS.PUBLIC
  }
}
